// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
// Actions
import { SalesTeamActions, SalesTeamActionTypes } from '../_actions/sales-team.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { SalesTeam } from '../_models/sales-team.model';

// tslint:disable-next-line:no-empty-interface
export interface SalesTeamsState extends EntityState<SalesTeam> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedSalesTeamId: number;
  lastQuery: QueryParamsModel;
  error: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<SalesTeam> = createEntityAdapter<SalesTeam>();

export const initialSalesTeamsState: SalesTeamsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedSalesTeamId: undefined,
  showInitWaitingMessage: true,
});

export function salesTeamsReducer(
  state = initialSalesTeamsState,
  action: SalesTeamActions,
): SalesTeamsState {
  switch (action.type) {
    case SalesTeamActionTypes.SalesTeamsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedSalesTeamId: undefined,
      };
    case SalesTeamActionTypes.SalesTeamsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case SalesTeamActionTypes.SalesTeamOnServerCreated:
      return {
        ...state,
      };
    case SalesTeamActionTypes.SalesTeamOnServerUpdated:
      return {
        ...state,
      };
    case SalesTeamActionTypes.SalesTeamStatusOnServerUpdated:
      return {
        ...state,
      };
    case SalesTeamActionTypes.SalesTeamsStatusOnServerUpdated:
      return {
        ...state,
      };
    case SalesTeamActionTypes.SalesTeamOnServerDeleted:
      return {
        ...state,
      };
    case SalesTeamActionTypes.ManySalesTeamsOnServerDeleted:
      return {
        ...state,
      };
    case SalesTeamActionTypes.SalesTeamCreated:
      return adapter.addOne(action.payload.salesTeam, {
        ...state,
        lastCreatedSalesTeamId: action.payload.salesTeam.id,
      });
    case SalesTeamActionTypes.SalesTeamUpdated:
      return adapter.updateOne(action.payload.partialSalesTeam, state);
    case SalesTeamActionTypes.SalesTeamStatusUpdated: {
      // tslint:disable-next-line
      const _partialSalesTeam: Update<SalesTeam> = {
        id: action.payload.id,
        changes: {
          //   is_active: action.payload.is_active
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialSalesTeam, state);
    }
    case SalesTeamActionTypes.SalesTeamsStatusUpdated: {
      // tslint:disable-next-line
      const _partialSalesTeams: Update<SalesTeam>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.salesTeams.length; i++) {
        _partialSalesTeams.push({
          id: action.payload.salesTeams[i].id,
          changes: {
            // is_active: action.payload.is_active === 1 ? true : false
          },
        });
      }
      return adapter.updateMany(_partialSalesTeams, state);
    }
    case SalesTeamActionTypes.SalesTeamDeleted:
      return adapter.removeOne(action.payload.id, state);
    case SalesTeamActionTypes.ManySalesTeamsDeleted: {
      const _ids = [];
      action.payload.ids.forEach((obj) => _ids.push(obj.id));
      return adapter.removeMany(_ids, state);
    }
    case SalesTeamActionTypes.SalesTeamsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case SalesTeamActionTypes.SalesTeamsPageLoaded: {
      return adapter.addMany(action.payload.salesTeams, {
        ...initialSalesTeamsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        listLoading: false,
        showInitWaitingMessage: false,
      });
    }
    case SalesTeamActionTypes.ThrowError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case SalesTeamActionTypes.ClearErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getSalesTeamState = createFeatureSelector<SalesTeamsState>('salesTeams');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
